import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { Box, PaginationGroup } from '@allied-solutions/affinity'
import { useWindowWidth } from '../../hooks'
import { theme } from '../../theme'

const PaginationControls = styled(Box)`
  button[id*='__PageButton--'] {
    width: ${({ theme: t }) => t.sizes[11]};
    min-width: ${({ theme: t }) => t.sizes[11]};
    height: ${({ theme: t }) => t.sizes[8]};
  }

  button[id*='__PageButton--'][aria-label^='Goto Page'] {
    background-color: ${({ theme: t }) => t.colors.buttons.white.background};
    color: ${({ theme: t }) => t.colors.text.secondary};

    &:hover:not(:disabled):not([aria-disabled='true']) {
      background-color: ${({ theme: t }) =>
        t.colors.buttons.white.hover.background};
    }
  }

  button[id*='__PageButton--'][aria-label^='Current Page'] {
    background-color: ${({ theme: t }) => t.colors.buttons.brand.background};
    color: ${({ theme: t }) => t.colors.text.white};

    &:hover:not(:disabled):not([aria-disabled='true']) {
      background-color: ${({ theme: t }) =>
        t.colors.buttons.brand.hover.background};
    }
  }

  && div:has(> button[id*='__PageButton--']) {
    gap: ${({ theme: t }) => t.space.md};
    width: auto;
  }
`

export const DashboardPagination = ({
  currentPage,
  totalItems,
  itemsPerPage,
  onChange,
}) => {
  const windowWidth = useWindowWidth()
  const isMobile = windowWidth < Number.parseInt(theme.breakpoints[1])
  return (
    <Box display="flex" justifyContent="center" my="4xl">
      <PaginationGroup
        id="dashboard-pagination"
        numItems={totalItems}
        itemsPerPage={itemsPerPage}
        currentPage={currentPage}
        onChange={onChange}
        compactNav={isMobile}
      >
        <PaginationControls display="flex" alignItems="center">
          <PaginationGroup.BackButton
            size="sm"
            mr={isMobile ? 'xs' : 'md'}
            px={isMobile ? 'xl' : '4xl'}
          />
          {isMobile ? (
            <Box mx="xl" whiteSpace="nowrap">
              <PaginationGroup.PageNumbers
                format="mobile"
                activeVariant="brand"
              />
            </Box>
          ) : (
            <PaginationGroup.PageNumbers activeVariant="brand" />
          )}
          <PaginationGroup.NextButton
            size="sm"
            ml={isMobile ? 'xs' : 'md'}
            px={isMobile ? 'xl' : '4xl'}
          />
        </PaginationControls>
      </PaginationGroup>
    </Box>
  )
}

DashboardPagination.propTypes = {
  currentPage: PropTypes.number.isRequired,
  totalItems: PropTypes.number.isRequired,
  itemsPerPage: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,
}
